import { Applicazione } from '../models/applicazione';
import { User } from 'oidc-client';
import auth, { AuthDataType } from '../types/auth';
import { ticketService } from '../services/ssoService';
import { SsoType } from '../utils/costanti';

export const K = {
    TICKET: 'SSO/TICKET',
}

const actions = {

    launchApplication: (item: Applicazione, ip: string, user: User, authData: AuthDataType, sso?: SsoType) => {
        console.log('sono in lauchapp');
        let { Url } = item;
        if (!Url) {
            throw new Error('Application URL not defined');
        }

        actions.ticket(item, ip, user, authData, sso)
            .then((tkt: string) => {
                if (!tkt) {
                    console.error('Ticket not generated', item);
                    // alert('Not ticket!!'); 
                    // alert('non ho trovato ticket service');
                    window.open(Url, '_blank');
                } else {
                    console.error('Ticket passed: ', tkt);
                    window.open(`${Url}?tkt=${tkt}`, '_blank');
                    // alert('ho trovato ticket service');
                    // console.log('No windows open')
                    // window.location.replace(`${Url}?tkt=${tkt}`);
                }
            });
    },

    ticket: (item: Applicazione, ip: string, user: User, authData: AuthDataType, sso?: SsoType): Promise<string> => {

        let ad = authData;
        let prov: string | null = null;
        let uffi: string | null = null;
        if (ad) {
            prov = ad.provinciaDefault;
            uffi = ad.ufficioDefault;
            // console.log('Prov = ' + prov);            
        } else {
            // throw new Error("AuthData not defined");
        }
        if (!prov)
            prov = '00';  // Assegno la provincia di sixtema

        // call the service
        return ticketService(ip, authData, user, item.Guid, item.Url, prov, uffi, item.Nome, sso)
            .then(({ ticket }: any) => ticket);
    }
}

export default actions;